const timeNowInUTC = (extraTime = 0) => {
  const timeZoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
  const now = new Date(Date.now() + timeZoneOffset + extraTime);
  return now;
};

export default timeNowInUTC;
